import { render, staticRenderFns } from "./OfficeCard.vue?vue&type=template&id=15f583a4&scoped=true&"
import script from "./OfficeCard.vue?vue&type=script&lang=ts&"
export * from "./OfficeCard.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeCard.vue?vue&type=style&index=0&id=15f583a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f583a4",
  null
  
)

export default component.exports